module.exports = __webpack_public_path__ + "img/Asset 65.60858b07.svg";